export default "__VITE_ASSET__cf28b378__"